import { createApi } from '@reduxjs/toolkit/query/react';
import { envVars } from '@/config';
import { fetchCustomBaseQuery } from '../fetcher';
import type { IGetCompetitionTypesRes } from '@/types';

export const competitionTypesApi = createApi({
  reducerPath: 'competitionApi',
  baseQuery: fetchCustomBaseQuery({
    baseUrl: envVars.backendUrl,
    mock: false,
  }),
  tagTypes: ['competitionTypes'],
  endpoints: (builder) => ({
    getCompetitionTypes: builder.query<IGetCompetitionTypesRes['data'], void>({
      query: () => ({
        url: '/cups-and-fpf/data',
        isProtected: false,
        method: 'get',
        forceMock: false,
        mockData: {
          message: 'Enum fetched successfully',
          data: ['CUP', 'FPF', 'HISTORY'],
        },
      }),
      transformResponse: (response: IGetCompetitionTypesRes) => response.data ?? [],
    }),
  }),
});

export const { useGetCompetitionTypesQuery } = competitionTypesApi;
